/**
 * <s-drag-scroll> adds mouse drag-to-scroll to its [data-drag-track] child.
 * Touch and trackpad scrolling stay native; a drag suppresses the click that follows it.
 */
class SDragScroll extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-drag-track]');
    if (!this.track) return;
    this.onDown = this.onDown.bind(this);
    this.onMove = this.onMove.bind(this);
    this.onUp = this.onUp.bind(this);
    this.onClick = this.onClick.bind(this);
    this.track.addEventListener('pointerdown', this.onDown);
    this.track.addEventListener('click', this.onClick, true);
    this.track.addEventListener('dragstart', (event) => event.preventDefault());
  }

  disconnectedCallback() {
    if (!this.track) return;
    this.track.removeEventListener('pointerdown', this.onDown);
    this.track.removeEventListener('click', this.onClick, true);
    window.removeEventListener('pointermove', this.onMove);
    window.removeEventListener('pointerup', this.onUp);
  }

  onDown(event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    this.startX = event.clientX;
    this.startScroll = this.track.scrollLeft;
    this.moved = false;
    this.dragging = true;
    window.addEventListener('pointermove', this.onMove);
    window.addEventListener('pointerup', this.onUp);
  }

  onMove(event) {
    if (!this.dragging) return;
    const delta = event.clientX - this.startX;
    if (!this.moved && Math.abs(delta) > 5) {
      this.moved = true;
      this.track.dataset.dragging = '';
    }
    if (this.moved) this.track.scrollLeft = this.startScroll - delta;
  }

  onUp() {
    this.dragging = false;
    delete this.track.dataset.dragging;
    window.removeEventListener('pointermove', this.onMove);
    window.removeEventListener('pointerup', this.onUp);
  }

  onClick(event) {
    if (!this.moved) return;
    event.preventDefault();
    event.stopPropagation();
    this.moved = false;
  }
}

if (!customElements.get('s-drag-scroll')) customElements.define('s-drag-scroll', SDragScroll);
